void main() {

    float distanceToCenter = distance(gl_PointCoord, vec2(0.5));
    float strength = 0.5 / distanceToCenter - 1.0;
    gl_FragColor = vec4(1.0, 1.0, 1.0, strength);

    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}